import React from 'react';

const SvgBackArrow = props => (
  <svg width={18} height={11} {...props}>
    <path
      d="M1.797 4.924H17.5a.5.5 0 0 1 .5.5v.009a.5.5 0 0 1-.5.5H1.664l4.216 4.216a.5.5 0 0 1 0 .707l-.006.006a.5.5 0 0 1-.708 0L.16 5.855l-.008-.008a.5.5 0 0 1 0-.707L5.153.138a.5.5 0 0 1 .707 0l.008.008a.5.5 0 0 1 0 .707l-4.07 4.07z"
      fill="#046FE2"
      fillRule="nonzero"
    />
  </svg>
);

export default SvgBackArrow;
